module.exports = __webpack_public_path__ + "img/slidedata-image-3.eaf91b71.jpg";